export const headCells = [
    {
        id: 'customer_desc',
        label: 'Customer',
        sortingRequired: true,
    },
    {
        id: 'l4',
        label: 'Product Class',
        sortingRequired: true,
    },
    {
        id: 'quantity',
        label: 'Potential Quantity (eaches/year)',
        sortingRequired: true,
    },
    {
        id: 'currentPortfolio',
        label: 'Potential Revenue ($)',
        sortingRequired: true,
    },
    {
        id: "currentRevenue",
        label:"Current Margin ($)",
        sortingRequired: true,
    },
    {
        id: 'aditionalMarginOpportunity',
        label: 'Additional Margin Opportunity ($)',
        sortingRequired: true,
    },
    {
        id: "marginOpportunity",
        label:"Margin Opportunity ($)",
        sortingRequired: true,
    }
];